export const omit = (key: string, obj: any = {}) => {
  // eslint-disable-next-line
  const { [key]: omitted, ...rest } = obj;
  return rest;
};
